import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-heading5',
  templateUrl: './heading5.component.html',
  styleUrls: ['./heading5.component.scss']
})
export class Heading5Component implements OnInit {
  @Input() text: string = ''
  @Input() isTextBlack: boolean = true
  constructor() { }

  ngOnInit(): void {
  }

}
